import {
    PHONE_VERIFICATION_FETCH_FAILURE,
    PHONE_VERIFICATION_FETCH_REQUEST,
    PHONE_VERIFICATION_FETCH_SUCCESS,
    PhoneVerificationFetchFailureAction,
    PhoneVerificationFetchRequestAction,
    PhoneVerificationFetchSuccessAction,
} from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification.actions';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface PhoneVerificationState {
    loadingState: LoadingState;
    errorMessage: string;
    alreadyVerified: boolean;
}

export const initialPhoneVerificationState: PhoneVerificationState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    alreadyVerified: null,
};

declare type PhoneVerificationReducerAction =
    PhoneVerificationFetchRequestAction
    | PhoneVerificationFetchSuccessAction
    | PhoneVerificationFetchFailureAction;

const phoneVerificationsReducer: Reducer<PhoneVerificationState> = (state = initialPhoneVerificationState, action: PhoneVerificationReducerAction) => {
    switch (action.type) {
        case PHONE_VERIFICATION_FETCH_REQUEST:
        case PHONE_VERIFICATION_FETCH_FAILURE: {
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });
        }

        case PHONE_VERIFICATION_FETCH_SUCCESS: {
            return tupdate(state, {
                alreadyVerified: action.response.result.alreadyVerified,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });
        }

        default:
            return state;
    }
};

export default phoneVerificationsReducer;
